import { createSlice } from '@reduxjs/toolkit';
import { calculateTotalAmount } from '../../utils/helper';
import { toast } from 'react-toastify';

const itemsFromLocal = JSON.parse(localStorage.getItem('cartItems')) || []; // Load wishlist items from local storage or initialize as empty
const initialTotal = calculateTotalAmount(itemsFromLocal); // calculate Initial total cart amount from local storage

const initialState = {
  items: itemsFromLocal,
  totalAmount: initialTotal,
};

// Helper function to recalculate total amount and update local storage
const updateCart = (state) => {
  state.totalAmount = calculateTotalAmount(state.items);
  localStorage.setItem('cartItems', JSON.stringify(state.items));
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // Add item to cart with specific quantity
    addItemToCart: (state, action) => {
      const { product, quantity = 1 } = action.payload; // Default quantity to 1 if not provided
      const existingItem = state.items.find((item) => item.id === product?.id); // Check if the ID already exists in addedProducts

      if (existingItem) {
        existingItem.quantity += quantity; // Increase quantity by specified amount
        toast.success(
          `${product?.title} quantity updated to ${existingItem.quantity}!`,
          {
            position: 'top-center',
          }
        ); // Show success message
      } else {
        const updatedProduct = {
          ...product,
          quantity: quantity,
        };

        state.items.push(updatedProduct); // Add new item with update quantity
        toast.success(`${product?.title} added to Cart!`, {
          position: 'top-center',
        }); // Show success message
      }
      updateCart(state); // Save the update cart items to local storage
    },
    // Remove item from cart
    removeItemFromCart: (state, action) => {
      const { id, title } = action.payload;
      state.items = state.items.filter((item) => item.id !== id);
      toast.info(`${title} removed from Cart.`, {
        position: 'top-center',
      }); // Show remove info message message

      updateCart(state); // Save the update cart items to local storage
    },
    // Increment the quantity of an item in the cart
    incrementQuantity: (state, action) => {
      const item = state.items.find((item) => item.id === action.payload); // Check if the ID already exists in addedProducts
      if (item) {
        item.quantity += 1; // Increase quantity by 1
        toast.success(`${item.title} quantity increased to ${item.quantity}.`, {
          position: 'top-center',
        }); // Show success message
        updateCart(state); // Save the update cart items to local storage
      }
    },
    // Decrement the quantity of an item in the cart
    decrementQuantity: (state, action) => {
      const item = state.items.find((item) => item.id === action.payload); // Check if the ID already exists in addedProducts
      if (item && item.quantity > 1) {
        item.quantity -= 1; // Decrease quantity by 1
        toast.info(`${item.title} quantity decreased to ${item.quantity}.`, {
          position: 'top-center',
        });
        updateCart(state); // Save the update cart items to local storage
      } else if (item && item.quantity === 1) {
        state.items = state.items.filter((item) => item.id !== action.payload);
        toast.info(`${item.title} removed from Cart.`, {
          position: 'top-center',
        });
        updateCart(state); // Save the update cart items to local storage
      }
    },
    // Clear all items from the cart
    clearCart: (state) => {
      state.items = [];
      state.totalAmount = 0;
      localStorage.removeItem('cartItems');
    },
  },
});

export const {
  addItemToCart,
  removeItemFromCart,
  incrementQuantity,
  decrementQuantity,
  clearCart,
} = cartSlice.actions;
export default cartSlice.reducer;
